import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { User } from '../../../domain/registrator';

@Component({
  selector: 'app-user-edit',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
  ],
  templateUrl: './user-edit.component.html',
  styleUrl: './user-edit.component.scss'
})
export class UserEditComponent implements OnInit {
  editMode: boolean = false;
  roleOptions: string[] = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SUPER'];

  form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<UserEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.fb.group({
      username: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(30), Validators.pattern('^[a-zA-Z0-9_-]+$')]],
      firstname: [''],
      lastname: [''],
      email: ['', [Validators.required, Validators.email]],
      roles: ['ROLE_USER', Validators.required]
    });
  }

  ngOnInit(): void {
    if (this.data && this.data.user) {
      this.editMode = true;
      const user: User = this.data.user;
      this.form.patchValue({
        username: user.username,
        firstname: user.firstname,
        lastname: user.lastname,
        email: user.email,
        roles: (user.roles?.length ? user.roles[0] : 'ROLE_USER')
      });
      this.form.get('username')!.disable();
    }
  }

  submit(): void {
    if (this.form.valid) {
      const payload: any = {
        username: this.form.get('username')!.value,
        firstname: this.form.value.firstname,
        lastname: this.form.value.lastname,
        email: this.form.value.email,
        roles: [this.form.value.roles]
      };
      this.dialogRef.close(payload);
    }
  }
}
